import Console from 'utility/Debug/Console';
import { getCheck24Namespace } from 'utility/Provide/Namespace/getCheck24Namespace';

import { GlobalNamespace } from 'types/legacy/namespace';
import { ToolbarModule } from 'types/legacy/toolbar';

import { DebugBar } from 'proto/DebugBar';

let toolbar: ToolbarModule;

const getToolBar = () => {
    if (toolbar === undefined) {
        toolbar = (getCheck24Namespace() as GlobalNamespace).components.ldt
            .toolbar ?? {
            handleDynamicDataUpdate: () => {},
        };
    }
    return toolbar;
};

export const mapRpcDebugBarData = (debugBar: DebugBar | undefined) =>
    debugBar
        ? Object.fromEntries<string>(
              debugBar.contentOrder.map((key: string) => [
                  key,
                  debugBar.content[key],
              ])
          )
        : undefined;

export const addDebugBarData = (
    data: Record<string, string> | undefined,
    name: string
) => {
    try {
        if (data) {
            getToolBar().handleDynamicDataUpdate(data, name);
        }
    } catch (e) {
        Console.error(e);
    }
};
